import { render } from "./DonutCard.vue?vue&type=template&id=5c8f6c21"
import script from "./DonutCard.vue?vue&type=script&lang=js"
export * from "./DonutCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__